/**
 * Kullanıcı Bildirim Kutusu Servisi
 *
 * Kullanıcıya gönderilmiş push bildirimlerini listeleme ve okundu işaretleme.
 * Tüm roller için. Singleton pattern.
 */

import apiService from '../api/api.service';
import {
  UserNotificationListQuery,
  UserNotificationListResponse,
} from '../../types/userNotification.types';

class UserNotificationService {
  private static instance: UserNotificationService;

  private constructor() {}

  public static getInstance(): UserNotificationService {
    if (!UserNotificationService.instance) {
      UserNotificationService.instance = new UserNotificationService();
    }
    return UserNotificationService.instance;
  }

  public async getNotifications(query: UserNotificationListQuery = {}): Promise<UserNotificationListResponse> {
    const { page = 1, limit = 20, unreadOnly = false } = query;
    return apiService.get<UserNotificationListResponse>('/user-notifications', {
      params: { page, limit, unreadOnly },
    });
  }

  public async getUnreadCount(): Promise<{ count: number }> {
    return apiService.get<{ count: number }>('/user-notifications/unread-count');
  }

  public async markAsRead(id: number): Promise<{ unreadCount: number }> {
    return apiService.patch<{ unreadCount: number }>(`/user-notifications/${id}/read`);
  }

  public async markAllAsRead(): Promise<{ unreadCount: number }> {
    return apiService.patch<{ unreadCount: number }>('/user-notifications/read-all');
  }
}

export default UserNotificationService.getInstance();
